import React, { useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import TextInputReferenciaFormik from "../../../../components/UI/TextInput/TextInputReferenciaFormik";
import useRetornaDataVencimento from "../hooks/useRetornaDataVencimento";

const DemonstrativoV = ({ formik, sqAcaoFiscal, sqItemOcorrencia, dadosOcorrencia }) => {
  const { calculaIcmsGeral, handleMoneyChange, calculaVendasArbitradas, calculaOmissaoVendas } = useAcoesDemonstrativo({
    formik,
    sqAcaoFiscal,
  });

  const { onBlurReferencia } = useRetornaDataVencimento({ formik });

  const { setFieldValue } = formik;

  useEffect(() => {
    if (dadosOcorrencia) {
      setFieldValue("sqAcaoFiscal", sqAcaoFiscal);
      setFieldValue("sqItemOcorrencia", sqItemOcorrencia);
      setFieldValue("sqItem", dadosOcorrencia.sqItem);
      setFieldValue("txReferencia", dadosOcorrencia.txReferencia);
      setFieldValue("dtVencimento", dadosOcorrencia.dtVencimento);
      setFieldValue("vlCMV", dadosOcorrencia.vlCMV);
      setFieldValue("pcVendas", dadosOcorrencia.pcVendas);
      setFieldValue("vlVendasArbitradas", dadosOcorrencia.vlVendasArbitradas);
      setFieldValue("vlVendasDeclaradas", dadosOcorrencia.vlVendasDeclaradas);
      setFieldValue("vlOmissaoSaidas", dadosOcorrencia.vlOmissaoSaidas);
      setFieldValue("vlBaseCalculo", dadosOcorrencia.vlBaseCalculo);
      setFieldValue("vlCredito", dadosOcorrencia.vlCredito);
      setFieldValue("pcIcmsAuditor", dadosOcorrencia.pcIcmsAuditor);
      setFieldValue("vlIcmsRecolhido", dadosOcorrencia.vlIcmsRecolhido);
      setFieldValue("vlIcms", dadosOcorrencia.vlIcms);
    }
  }, [setFieldValue, dadosOcorrencia, sqAcaoFiscal, sqItemOcorrencia]);

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={2}>
          <Form.Label>Referência:</Form.Label>
          <TextInputReferenciaFormik
            formik={formik}
            field="txReferencia"
            placeholder="mm/aaaa ou dd/mm/aaaa"
            mask=""
            evento={onBlurReferencia}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={4} md={8}>
          <Form.Label>Data de Vencimento:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Custo Mercadorias Vendidas (R$):</Form.Label>
          <TextInputMoneyFormik formik={formik} field="vlCMV" type="number" prefix=" " onChange={handleMoneyChange} />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Margem Vendas (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="pcVendas"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            evento={calculaVendasArbitradas}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Vendas Arbitradas:</Form.Label> {"  "}
          <Form.Label>
            {formik.values.vlVendasArbitradas
              ? formik.values.vlVendasArbitradas.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
              : formik.values.vlVendasArbitradas}
          </Form.Label>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Vendas Declaradas (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlVendasDeclaradas"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            evento={calculaOmissaoVendas}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Omissão de Saídas:</Form.Label> {"  "}
          <Form.Label>
            {formik.values.vlOmissaoSaidas
              ? formik.values.vlOmissaoSaidas.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
              : formik.values.vlOmissaoSaidas}
          </Form.Label>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor Base de Cálculo (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlBaseCalculo"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor Deduções/Crédito (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlCredito"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label> Aliquota (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="pcIcmsAuditor"
            type="number"
            prefix="  "
            onChange={handleMoneyChange}
            evento={calculaIcmsGeral}
          />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>
            <strong>ICMS a Recolher (R$):</strong>
          </Form.Label>{" "}
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcms"
            prefix=" "
            type="number"
            onChange={handleMoneyChange}
            disable
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default DemonstrativoV;
